// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".theme--light.v-stepper .v-stepper__step__step .v-icon{line-height:1.25rem;font-size:.75rem}button.v-expansion-panel-header{border:none;background:transparent}.v-stepper__header .v-ripple__container{display:none}.v-stepper__header .v-stepper__step--complete .v-icon__svg{padding:4px}.v-stepper__step{padding:0 1.5rem}", ""]);
// Exports
module.exports = exports;
